import { render, staticRenderFns } from "./SearchLeads.vue?vue&type=template&id=bb2ac530&scoped=true&"
import script from "./SearchLeads.vue?vue&type=script&lang=js&"
export * from "./SearchLeads.vue?vue&type=script&lang=js&"
import style0 from "./SearchLeads.vue?vue&type=style&index=0&id=bb2ac530&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2ac530",
  null
  
)

export default component.exports